// extracted by mini-css-extract-plugin
export var button = "_li-0";
export var donut = "_li-1";
export var donutFill = "_li-3";
export var donutTrack = "_li-2";